// import {
//     asyncRoutes,
//     constantRoutes
// } from '@/router'
import {
    getMenu
} from '@/api/user'
import Layout from '@/layout'
// import Project from '@/views/project/index.vue'
import {
    constantRouter
} from '@/router'

// 添加实例
export function generaMenu(routes, data) {
    data.forEach(item => {
        const menu = {
            path: item.path === '#' ? item.id + '_key' : item.path,
            component: item.component === 'Layout' ? Layout : () => import(`@/views${item.component}`),
            hidden: item.hidden,
            redirect: item.redirect,
            children: [],
            meta: item.meta
        }

        if (item.children) {
            generaMenu(menu.children, item.children)
        }
        routes.push(menu)
    })
}


const state = {
    routes: [],
    addRoutes: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = (routes)
    }
}

// 添加路由
const actions = {
    generateRoutes({
        commit
    }) {
        return new Promise(resolve => {
            getMenu({
                id: 1
            }).then(res => {
                let getMenu = []
                res.forEach(item => {
                    let getChildMenu = []
                    item.apps.forEach(it => {
                        getChildMenu.push({
                            path: it.name,
                            name: it.name,
                            component: '/projectItem/index',
                            meta: {
                                title: it.name,
                                id: it.id,
                                icon: 'App'
                            },
                            hidden: false,
                        })
                    })
                    getMenu.push({
                        path: item.name,
                        name: item.name,
                        component: '/projectItem/index',
                        meta: {
                            title: item.name,
                            id: item.id,
                            icon: 'xiangmu'
                        },
                        hidden: false,
                        children: getChildMenu
                    })
                    getChildMenu = []
                })
                let newRouter = []
                const a = [{
                    path: '/project',
                    component: 'Layout',
                    meta: {
                        title: '项目列表',
                        icon: 'liebiao'
                    },
                    hidden: false,
                    children: getMenu
                }]
                
                // 便利路由，import 实例
                generaMenu(newRouter, a)
                commit('SET_ROUTES', newRouter)
                // 拼接固定路由
                // resolve(constantRouter.concat(newRouter))
                resolve(constantRouter)

            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}